<span [ngbTooltip]="tooltip">{{ text }}</span>